<template>
  <div class="row h-100">
    <div class="col-12 h-100">
      <div class="poppins planned-content h-100">
        <div class="h-100 d-flex flex-column" v-if="loaded">
          <BlockHeader name="Details" class="mt-0" />
          <div class="row">
            <div class="col-lg-6 col-sm-8 col-8">
              <Select v-model="selectedYear" :onChange="init" :options="yearOptions" form-group-id="Year" placeholder="year" />
            </div>
            <div class="col-lg-6 col-sm-4 col-4 actions-wrapper mt-4 pt-1">
              <b-button variant="primary" size="lg" @click="exportCSV" class="export-btn">
                {{ 'export' | i18n }}
              </b-button>
              <div class="arrows-block">
                <b-button variant="primary" size="lg" @click="scrollShift(-600)">
                  <BIconArrowLeft />
                </b-button>
                <b-button variant="primary" size="lg" @click="scrollShift(600)">
                  <BIconArrowRight />
                </b-button>
              </div>
            </div>
          </div>
          <div class="table-wrapper w-100 overflow-auto" v-if="data.length">
            <table class="roboto-mono" ref="tableData">
              <thead>
                <tr>
                  <th
                    v-for="field in fields"
                    :key="field.name"
                    :style="`
                      background:${field.color};
                      ${field.noRotate ? 'text-align: center;' : 'position: relative; height: 395px; min-width: 50px;'}
                    `"
                  >
                    <!-- class="rotate-header" -->
                    <div :class="!field.noRotate ? 'rotate-header' : ''">
                      {{ field.name | i18n }}&nbsp;
                      <span v-if="field.value">{{ ' ' }}[{{ field.value }}]</span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="line in data" :key="line.date">
                  <td
                    v-for="field in fields"
                    :key="`${field.name}-${line.date}`"
                    class="roboto-mono"
                    :style="`background:${field.color};white-space: nowrap;`"
                  >
                    {{
                      field.name === 'Date'
                        ? moment(line[field.name]).format('DD-MM-YYYY')
                        : field.noFormat
                        ? line[field.name]
                        : format(line[field.name])
                    }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-else class="no-data">
            {{ 'no_table_data' | i18n }}
          </div>
        </div>
        <Loader v-else />
      </div>
    </div>
  </div>
</template>

<script>
import { BIconArrowRight, BIconArrowLeft } from 'bootstrap-vue';
import moment from 'moment';
import api from '../../../api';

import Select from '../../common/select';
import Loader from '../../common/loader';
import BlockHeader from '../../common/block-header';

const currentYear = Number(moment().format('YYYY'));

export default {
  title: 'RMVA',
  components: { Loader, BlockHeader, Select, BIconArrowRight, BIconArrowLeft },
  data() {
    return {
      loaded: false,
      isSaving: false,
      selectedYear: currentYear,
      yearOptions: [],
      data: [],
      moment: moment,
      fields: [
        {
          name: 'KW',
          noRotate: true,
          noFormat: true,
        },
        {
          name: 'Anl. Tag',
          noRotate: true,
          noFormat: true,
        },
        {
          name: 'Date',
          noRotate: true,
        },
      ],
      blocks: [
        {
          name: 'grey',
          color: 'rgb(227,226,226)',
          value: 't',
          fields: [
            'Plan Verbrennung Linie 1',
            'Plan Verbrennung Linie 2',
            'Plan Verbrennung Linie 3',
            'Plan Verbrennung Linie 4',
            'Plan Verbrennung gesamt',
            'Plan Verbrennung gesamt kumuliert',
            'Ist Verbrennung Linie 1',
            'Ist Verbrennung Linie 2',
            'Ist Verbrennung Linie 3',
            'Ist Verbrennung Linie 4',
            'Ist Verbrennung gesamt',
            'Ist Verbrennung gesamt kumuliert',
            'Diff Verbrennung gesamt kumuliert',
          ],
        },
        {
          name: 'pink',
          color: 'rgb(239,198,166)',
          value: 'MWh',
          fields: [
            'Plan Stromlieferung gesamt',
            'Plan Stromlieferung gesamt kumuliert',
            'Plan Wärmelieferung',
            'Plan Wärmelieferung kumuliert',
            'Plan Energielieferung',
            'Plan Energielieferung kumuliert',
            'Ist Stromlieferung 110kV',
            'Ist Stromlieferung 25kV',
            'Ist Stromlieferung gesamt',
            'Ist Stromlieferung gesamt kumuliert',
            'Ist Wärmelieferung',
            'Ist Wärmelieferung kumuliert',
            'Ist Energielieferung',
            'Ist Energielieferung kumuliert',
            'Diff Stromlieferung kumuliert',
            'Diff Wärmelieferung kumuliert',
            'Diff Energielieferung kumuliert',
            'Plan Strombezug kumuliert',
            'Ist Strombezug',
            'Ist Strombezug kumuliert',
            'Diff Strombezug kumuliert',
          ],
        },
        {
          name: 'yellow',
          color: 'rgb(253,241,200)',
          value: 'm³',
          fields: ['Plan Erdgasverbrauch kumuliert', 'Ist Erdgasverbrauch', 'Ist Erdgasverbrauch kumuliert', 'Diff Erdgasverbrauch kumuliert'],
        },
        {
          name: 'blue',
          color: 'rgb(213,220,239)',
          value: 'l',
          fields: ['Plan Heizölverbrauch kumuliert', 'Ist Heizölverbrauch', 'Ist Heizölverbrauch kumuliert', 'Diff Heizölverbrauch kumuliert'],
        },
      ],
    };
  },

  async created() {
    const yearList = await api.year.get();
    this.yearOptions = yearList.data.map(({ year }) => year);
    this.selectedYear = localStorage.getItem('selectedYear') || currentYear;
    this.blocks.forEach((block) => {
      block.fields.forEach((field) => {
        this.fields.push({
          name: field,
          color: block.color,
          value: block.value,
        });
      });
    });
    this.init();
  },
  methods: {
    scrollShift(offset) {
      document.querySelector('.table-wrapper').scrollLeft += offset;
    },
    addZeroes(num) {
      const dec = String(num).split(',');
      if (!dec[1]) {
        dec[1] = '00';
      }
      if (dec[1].length === 1) {
        dec[1] = `${dec[1]}0`;
      }
      return `${dec[0]},${dec[1]}`;
    },
    format(n) {
      return this.addZeroes(new Intl.NumberFormat('de-DE').format(Number(n).toFixed(2)));
    },
    async init() {
      localStorage.setItem('selectedYear', this.selectedYear);
      this.loaded = false;
      const responce = await api.RMVA.get({ year: this.selectedYear });
      this.data = responce.map((i) => ({
        ...i,
        KW: i['Kalender-woche'],
        'Anl. Tag': i['Anliefertag des Jahres'],
        Date: i.date,
      }));
      this.loaded = true;
    },
    exportCSV() {
      const table = this.$refs.tableData;

      const rows = table.getElementsByTagName('tr');
      const csvData = [...rows].map((row) => {
        const cols = row.querySelectorAll('td,th');
        const csvRow = [...cols].map((col) => {
          let data = col.innerText;
          data = data.split('\n').join(' ');
          if (data.includes(',')) {
            data = `"${data}"`;
          }
          if (col.colSpan > 1) {
            const colSpanArr = [...Array(col.colSpan - 1).keys()].map(() => ';');
            data = [data, ...colSpanArr].join('');
          }
          return data;
        });
        return csvRow.join(';');
      });
      const csvFinalData = csvData.join('\n');

      const csvFile = new Blob(['\uFEFF' + csvFinalData], { type: 'text/csv; charset=utf-8' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(csvFile);
      link.download = 'RMVA_values';
      link.click();
      URL.revokeObjectURL(link.href);
    },
  },
};
</script>

<style scoped lang="scss">
.planned-content {
  overflow-x: hidden;
}

.line-value {
  display: flex;
  margin-left: 20px;
  align-items: center;
  box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  margin-top: 20px;
  padding: 10px;
}

.type-value {
  margin-left: 10px;
  width: 90px;
}

table,
td,
th {
  box-shadow: inset 0 0 0 1px #333;
  background: white;
}
th {
  padding: 5px;
}
td {
  padding: 5px;
  text-align: right;
}
tr th:first-child,
tr td:first-child {
  position: sticky;
  left: 0;
  width: 45px;
  min-width: 45px;
  max-width: 45px;
}
tr th:nth-child(2),
tr td:nth-child(2) {
  position: sticky;
  left: 45px;
  width: 60px;
  min-width: 60px;
  max-width: 60px;
}
tr th:nth-child(3),
tr td:nth-child(3) {
  position: sticky;
  left: 105px;
}
tr th:first-child,
tr th:nth-child(2),
tr th:nth-child(3) {
  z-index: 1;
}
thead {
  position: sticky;
  top: 0;
  z-index: 1;
}

.no-data {
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.rotate-header {
  -ms-writing-mode: tb-rl;
  -webkit-writing-mode: vertical-rl;
  -moz-writing-mode: vertical-rl;
  -ms-writing-mode: vertical-rl;
  writing-mode: vertical-rl;
  transform: rotate(-180deg);
  white-space: nowrap;
  height: 330px;
  position: absolute;
  top: 58px;
  display: flex;
  align-items: center;
  width: 100%;
  right: 1px;
}

.arrows-block {
  margin-left: 50px;
  display: flex;
  width: 90px;
  justify-content: space-between;
}

.export-btn {
  display: block;
}

.actions-wrapper {
  flex-direction: row;
  justify-content: flex-end;
  display: flex;
  align-items: flex-start;
}

::v-deep .btn-lg {
  font-size: 16px;
  line-height: 30px;
}
</style>
